// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel {
    static getAttributeTypeMap() {
        return SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.attributeTypeMap;
    }
}
SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.discriminator = undefined;
SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.additionalProperties = false;
SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel"
    },
];
//# sourceMappingURL=sharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.js.map